import React from 'react';

const stats = [
  { k: '$90B', v: 'GLOBAL REMARKETING MARKET 2024' },
  { k: '$120B', v: 'MARKET BY 2033 · 33% GROWTH' },
  { k: '10×', v: 'HIGHER CTR VS STANDARD DISPLAY' },
  { k: '70%', v: 'MORE LIKELY TO CONVERT' },
  { k: '161%', v: 'CONVERSION LIFT POSSIBLE' },
  { k: '71%', v: 'HIGHER ROAS WITH SEGMENTATION' },
];

const statColors = ['#00e0ff', '#22d07a', '#ff6b38'];

export default function MarketSection() {
  return (
    <section className="py-12 lg:py-16 bg-[#262626] relative overflow-hidden" id="market" data-testid="market-section">
       <div className="highlights-glow highlights-glow-one" />
      <div className="highlights-glow highlights-glow-two" />
      <div className="container-r360 ">
        <div className="highlights-kicker text-white">
          <span />MARKET OPPORTUNITY
        </div>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 xl:gap-10 md:gap-6 items-start">
           <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.25rem] sm:text-[4.5rem] xl:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em]">
            A <span className="accent">$90B</span> Under Performing
          </h2>
          <div className="lg:col-span-5">
            <p className="reveal-on-scroll leading-relaxed sec-subhead text-white">
             The global remarketing market is massive, yet billions are wasted on outdated CPM/CPC models that reward clicks—not results. Retarget360.ai closes that performance gap with AI-driven remarketing built to maximise conversions, efficiency, and measurable revenue growth.
            </p>
          </div>
        </div>
  
        <div className="grid grid-cols-2 lg:grid-cols-3 border-t border-l border-[#5a5a5a] mt-8">
          {stats.map((s, i) => (
            <div key={i} className="border-r border-b border-[#5a5a5a] p-4 md:p-8 lg:p-10">
              <div
                className="font-display text-[2.25rem] md:text-[3.25rem] lg:text-[4.25rem] font-black leading-none"
                style={{ color: statColors[i % statColors.length] }}
              >
                {s.k}
              </div>
              <div className="font-mono text-[14px] lg:text-[16px] font-medium mt-2 md:mt-4 text-white leading-[1.5em]">{s.v}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 lg:mt-10 bg-[#0b0b0b] p-4 lg:p-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 lg:gap-6">
          <div className="flex items-center gap-3">
            <span className="text-[#00e0ff] text-xl">▲</span>
            <span className="text-[15px] font-medium text-[#f0f0f0]">Dynamic retargeting delivers 50–150% higher ROAS vs static campaigns.</span>
          </div>
          <div className="flex items-start gap-3">
             <span className="text-[#00e0ff] text-xl">▲</span>
             <span  className="text-[15px] font-medium text-[#f0f0f0]">$260B recoverable in US + EU alone.</span>
          </div>
        </div>
      </div>
    </section>
  );
}
